import { useContext } from "react";
import { NavigationContext } from "contexts";

export default () => useContext(NavigationContext);
